import { ImpactFigure } from "../../../../components/impact-figure/impact-figure"
import { Quote } from '../../../../components/quote/quote'

import { Reveal } from "../../../../animation/reveal"

import CSS from './in-numbers.module.css'

export const InNumbers = () => {

    const sectionHeading = `fs-1 c-secondary lh-1 caps`
    
    return (
        <section className={CSS.layout}>
            
            <div className={CSS.quote}>
                <Quote 
                    avatar={{ url: `https://cms.thebench.com/assets/img/avatars/Adedayo-Olawuyi-Head-shot.jpg`, alt: `Adedayo Olawuyi`}}
                    quote={`AviaDev continues to live up to its name and objective, it is indeed Africa's one-stop shop for route and aviation development.`} 
                    name={`Adedayo Olawuyi`} 
                    title={`United Nigeria Airlines`}
                    decal={`c-primary fs-3 caps`}
                />
                <div className="mt-md">
                    <Quote 
                        avatar={{ url: `https://cms.thebench.com/assets/img/avatars/Ariana-Headshot.jpg`, alt: `Ariana McKnire`}}
                        quote={`AviaDev Africa is engaging and inspiring for developing industry connections and executing on great market opportunities.`} 
                        name={`Ariana McKnire`} 
                        title={`Metropolitan Washington Airports Authority`}
                        decal={`c-primary fs-3 caps`}
                    />
                </div>
            </div>
            
            <div className={CSS.impact}>
                <Reveal>
                    <p className={sectionHeading}>AviaDev in numbers</p>
                </Reveal>
                <div className={CSS.impactGrid}>
                    <ImpactFigure figure={`550+`} caption={`Delegates`} />
                    <ImpactFigure figure={`51`} caption={`Airlines`} />
                    <ImpactFigure figure={`72%`} caption={`Attendees from Africa`} />
                    <ImpactFigure figure={`1750+`} caption={`Pre-arranged meetings delivered`} />
                    <ImpactFigure figure={`50`} caption={`Countries represented`} />
                </div>
            </div>
        </section>
    )
}